import { STORE_COMPANY_PREFS, STORE_USER_PREFS } from '@core/local-storage/local-storage'
import { CompanyPreference } from '@core/models/preference/company-preference'
import { UserPreference } from '@core/models/preference/user-preference'
import { environment } from '@environments/environment'
import { getWindow } from '@vendor/window/window'

export interface IPreferenceState {
    user: {
        [id: string]: UserPreference
    },
    company: {
        [id: string]: CompanyPreference
    }
}

export function initialPreferenceState(): IPreferenceState {
    
    const window: any = getWindow();
    let user = {};
    let company = {};

    try {

        user = JSON.parse(window.localStorage.getItem(`${ environment.settings.localStoragePrefix }.${ STORE_USER_PREFS }`) || null) || {};
    
    } catch (error) {
        console.error(error);
    }

    try {
        company = JSON.parse(window.localStorage.getItem(`${ environment.settings.localStoragePrefix }.${ STORE_COMPANY_PREFS }`) || null) || {};
    
    } catch (error) {
        console.error(error);
    }

    return {
        user,
        company
    }
}